import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { Link,useSearchParams } from "react-router-dom";
import * as Fa from "react-icons/fa";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { useEffect } from "react";
import Loader from "../../Components/Loader";
import { useState } from "react";
import { createAPIEndpoint, Endpoint } from "../../Services/RSECustomerService";
import storage from "../../Services/Storage";
import { toast } from "react-toastify";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { InputSwitch } from "primereact/inputswitch";

const RSECustomerDetails = () => {
    const auth = storage.getLocal("user");
    const [searchparam] = useSearchParams();
    let csdCode = searchparam.get("csdCode");
    let partyCode = searchparam.get("partyCode");
    let partyId = searchparam.get("partyId");
    console.log(partyId,"partyId");
    const[loading, setLoading] = useState(false);
    const[surePopup, setSurePopup] = useState(false);
    const[filterData, setFilterData] = useState([]);
    const[geogDetl, setGeogDetl] = useState([]);
    const[decision, setDecision] = useState("");
    const[rejectComments, setRejectComments] = useState("");
    const[isActive, setIsActive] = useState(true);

    const GetFilterRSECust = async () => {
        setLoading(true);
        try {
            
            const response = await createAPIEndpoint().get(`${Endpoint.GetRSECustList}?CompId=${auth.CompId}`);
            const filterData = response.data.Data.filter((a)=>{return a.CSD_CODE+a.DEALER_CODE===csdCode+partyCode;});
            setFilterData(filterData);
            if(filterData[0]?.PROCESS_STATUS === "Accepted"){
                if(filterData[0]?.STATUS==="Y"){
                    setIsActive(true);
                }else{
                    setIsActive(false);
                }
            }
            const res = await createAPIEndpoint().get(`${Endpoint.GetGEOGInfo}?GeogId=${filterData[0]?.PARTY_ADD_GEOG_ID}`);
            setGeogDetl(res.data.Data);
        } catch (error) {
            console.log("error ", error);
        }finally{
            setLoading(false);
        }
    };
    const OnSaveClick = async () => {
        try{
            setLoading(true);
            const obj = {
                PartyId: partyId,
                IsActive: isActive===true?"Y":"N"
            };
            console.log(obj,"OnSaveClick");
            const res = await createAPIEndpoint().post(Endpoint.UpdateActiveStatus,JSON.stringify(obj));
            if(res.data.Status === "Success"){
                toast.success(res.data.Message, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            }else{
                toast.warning("Something error occurred. Please contact with InnoRise helpdesk", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            }
        }catch(ex){
            console.log(ex);
        }finally{
            setLoading(false);
        }
    };
    const ApproveReject = async (operation) => {
        setLoading(true);
        try{
            if(operation==="R"){
                if(rejectComments.length == 0){
                    toast.warning("Please enter reject reason", {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    });
                    return;
                }
            }
            const obj = {
                compId : auth.CompId,
                csdId : filterData[0]?.CSD_CODE,
                dealerId : filterData[0]?.DEALER_ID,
                userId : auth.UserId,
                status : operation,
                msg : rejectComments
            };
            const res = await createAPIEndpoint().post(Endpoint.ApproveReject,JSON.stringify(obj));
            if(res.data.Status === "Success"){
                toast.success(res.data.Message, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setSurePopup(false);
            }else{
                toast.warning("Something error occurred. Please contact with InnoRise helpdesk", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setSurePopup(false);
            }
            GetFilterRSECust();
        }catch(ex){
            toast.error(ex?.response?.data?.Message, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        }finally{
            setLoading(false);
        }
    };
    const footerContent = (
        <div>
            <div className="text-end">
                <button
                    type="button"
                    className="btn btn-primary me-3"
                    onClick={() => decision==="AP"?ApproveReject("AP"):ApproveReject("R")}
                >
          Yes <Fa.FaCheck />
                </button>
                <button
                    type="button"
                    className="btn btn-cancel-red"
                    onClick={() => {
                        setSurePopup(false);
                        setRejectComments("");
                    }}
                >
          No <Fa.FaTimes />
                </button>
            </div>
        </div>
    );
    useEffect(()=>{
        GetFilterRSECust();
    },[]);
    if(loading){
        return(<Loader/>);
    }
    else{
        return (
            <>
                <main>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mx-1">
                                    <li className="breadcrumb-item">
                                        <Link to="/masters/ruralserviceexpress">Rural Service Express</Link>
                                    </li>
                                    <li
                                        className="breadcrumb-item active"
                                        aria-current="page"
                                    >
                        Details
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="text-end">
                                <Link to="/masters/ruralserviceexpress">
                                    <button type="button" className="btn btn-primary">
                                        <Fa.FaLongArrowAltLeft className="backIcon" /> Back to
                        All Records
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <form>
                            <Accordion defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        {/* <div style={{ color: "red" }}>
                                                CSD Details <Fi.FiAlertTriangle />
                                                </div> */}
                                        <>CSD Details</>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className="row">
                                            <div className="col-lg-4 col-md-4 col-sm-12 mb-2">
                                                <label className="form-label">CSD Code</label>
                                                <InputText
                                                    className="form-control"
                                                    disabled
                                                    value={filterData[0]?.CSD_CODE}
                                                />
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-12 mb-2">
                                                <label className="form-label">CSD Name</label>
                                                <InputText
                                                    className="form-control"
                                                    disabled
                                                    value={filterData[0]?.CSD_NAME}
                                                />
                                            </div>
                                            <div className="col-lg-2 col-md-2 col-sm-12 mb-2">
                                                <label className="form-label">Start Date</label>
                                                <Calendar
                                                    className="form-label"
                                                    disabled
                                                    value={
                                                        filterData[0]?.PROCESS_STATUS === "Pending"
                                                            ? new Date()
                                                            : new Date(filterData[0]?.LAST_MODIFIED_ON)
                                                    }
                                                    dateFormat="dd/mm/yy"
                                                />
                                            </div>
                                            <div className="col-lg-2 col-md-2 col-sm-12 mb-2">
                                                <label className="form-label">Status</label>
                                                <InputText
                                                    className="form-control"
                                                    disabled
                                                    value={filterData[0]?.PROCESS_STATUS}
                                                />
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        {/* <div style={{ color: "red" }}>
                                                Dealer To RSE <Fi.FiAlertTriangle />
                                                </div> */}
                                        <>RSE Details</>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className="row">
                                            <div className="col-lg-4 col-md-4 col-sm-12 mb-2">
                                                <label className="form-label">Code</label>
                                                <InputText
                                                    className="form-control"
                                                    disabled
                                                    value={filterData[0]?.DEALER_CODE}
                                                />
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-12 mb-2">
                                                <label className="form-label">Name</label>
                                                <InputText
                                                    className="form-control"
                                                    disabled
                                                    value={filterData[0]?.DEALER_NAME}
                                                />
                                            </div>
                                            <div className="col-lg-4 col-md-4 col-sm-12 mb-2">
                                                <label className="form-label">PID</label>
                                                <InputText
                                                    className="form-control"
                                                    disabled
                                                    value={filterData[0]?.DEALER_PID}
                                                />
                                            </div>
                                            {filterData[0]?.PROCESS_STATUS === "Accepted" && <div className="col-lg-3 col-md-6 col-sm-12">
                                                <label className="form-label">Active</label>
                                                <label className="d-inline ms-2">
                                                    <InputSwitch
                                                        className="switch-pos"
                                                        id="status"
                                                        name="status"
                                                        checked={isActive}
                                                        onChange={(e) => {
                                                            setIsActive(e.value);
                                                        }}
                                                    />
                                                </label>
                                            </div>}
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        {/* <div style={{ color: "red" }}>
                                                Address <Fi.FiAlertTriangle />
                                                </div> */}
                                        <>Address</>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                                                <label className="form-label">Address 1</label>
                                                <InputText
                                                    className="form-control"
                                                    disabled
                                                    value={filterData[0]?.PARTY_ADD_LINE1}
                                                />
                                            </div>
                                            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
                                                <label className="form-label">Address 2</label>
                                                <InputText
                                                    className="form-control"
                                                    disabled
                                                    value={filterData[0]?.PARTY_ADD_LINE2}
                                                />
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-12 mb-2">
                                                <label className="form-label">Town</label>
                                                <InputText
                                                    className="form-control"
                                                    disabled
                                                    value={geogDetl[0]?.TOWN}
                                                />
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-12 mb-2">
                                                <label className="form-label">District</label>
                                                <InputText
                                                    className="form-control"
                                                    disabled
                                                    value={geogDetl[0]?.DISTRICT}
                                                />
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-12 mb-2">
                                                <label className="form-label">State</label>
                                                <InputText
                                                    className="form-control"
                                                    disabled
                                                    value={geogDetl[0]?.STATE}
                                                />
                                            </div>
                                            <div className="col-lg-3 col-md-3 col-sm-12 mb-2">
                                                <label className="form-label">Pin Code</label>
                                                <InputText
                                                    className="form-control"
                                                    disabled
                                                    value={filterData[0]?.PARTY_ADD_PIN}
                                                />
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                            {filterData[0]?.PROCESS_STATUS === "Pending" && (
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="float-end my-3">
                                        <button
                                            type="button"
                                            className="btn btn-primary me-3"
                                            onClick={() => {setDecision("AP");setSurePopup(true);}}
                                        >
                          Accept <Fa.FaCheck className="ms-2" />
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-cancel-red"
                                            onClick={() => {setDecision("R");setSurePopup(true);}}
                                        >
                          Reject <Fa.FaTimes className="ms-2" />
                                        </button>
                                    </div>
                                </div>
                            )}
                            {filterData[0]?.PROCESS_STATUS === "Accepted" && (
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="float-end my-3">
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={() => {OnSaveClick();}}
                                        >
                          Save <Fa.FaCheck className="ms-2" />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </form>
                    </div>

                    <Dialog
                        header="Confirmation"
                        visible={surePopup}
                        style={{ width: "40vw" }}
                        onHide={() => setSurePopup(false)}
                        closable={false}
                        resizable={false}
                        draggable={false}
                        footer={footerContent}
                    >
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <p className="text-center">
                                {decision==="AP"?<>Do you want to <span className="text-success">&quot;Accept&quot;</span> this record ?</>:<>Do you want to <span className="text-danger">&quot;Reject&quot;</span> this record ?</>}
                            </p>
                            {decision==="R"&&(<form>
                                <label className="form-label">Reason</label>
                                <InputTextarea 
                                    className="form-control"
                                    type="text"
                                    value={rejectComments}
                                    onChange={(e) => setRejectComments(e.target.value)}
                                    maxLength={200}
                                />
                                <small className="p-error mt-2 text-end">
                  Character left : {200 - rejectComments.length}
                                </small>
                            </form>)}
                        </div>
                    </Dialog>
                </main>
            </>
        );
    }
};

export default RSECustomerDetails;